import React from 'react';

export const SiteFooter: React.FC = () => {
  return (
    <footer className="border-t bg-background py-4 px-4">
      <div className="container flex flex-col items-center justify-between gap-3 text-center sm:flex-row sm:text-left">
        <p className="text-xs sm:text-sm text-muted-foreground">
          {new Date().getFullYear()} Jugar Hoy! Todos los derechos reservados.
        </p>
        <div className="flex gap-4 text-xs sm:text-sm">
          <a
            href="/support"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            Contacto
          </a>
          <span className="text-muted-foreground">•</span>
          <a
            href="/terms"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            Términos y Condiciones
          </a>
          <span className="text-muted-foreground">•</span>
          <a
            href="/privacidad"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>
  );
};
